import styled from "styled-components";
import { gray18 } from "../../../../config/colors";

export const StyledPaneContent = styled.div`
  padding-top: 20px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
`;

export const StyledSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  margin-bottom: 60px;
`;
